import { useRef } from 'react';
import QRCode from 'react-qr-code';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import PropTypes from 'prop-types';
import ModalComponent from 'components/common/ModalComponent';
import ButtonComponent from 'components/common/ButtonComponent';
import { QR_TYPES } from 'constants/qr.types';

const FarmQRModal = ({ isOpen, onClose, farmId, farmName }) => {
  const qrRef = useRef(null);

  const handlePrintQR = async () => {
    if (!qrRef.current) return;

    try {
      const canvas = await html2canvas(qrRef.current);
      const imgData = canvas.toDataURL('image/png');

      const pdf = new JsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgWidth = 100;
      const imgHeight = 100;
      const x = (pdfWidth - imgWidth) / 2;
      const y = 40;

      pdf.setFontSize(14);
      pdf.setTextColor(34, 139, 34);
      pdf.text(`Farm: ${farmName}`, pdfWidth / 2, y - 20, { align: 'center' });

      pdf.setFontSize(12);
      pdf.setTextColor(80, 80, 80);
      pdf.text(`Farm ID: ${farmId}`, pdfWidth / 2, y - 10, { align: 'center' });

      pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
      pdf.save(`farm-qr-${farmId}.pdf`);
    } catch (err) {
      console.error('Failed to print QR:', err);
    }
  };

  return (
    <ModalComponent title="Farm QR Code" onClose={onClose} isOpen={isOpen} hideDefaultFooter>
      <div className="space-y-6 max-w-md mx-auto">
        <div className="flex flex-col items-center" ref={qrRef}>
          <QRCode value={JSON.stringify({ qrType: QR_TYPES.FARM, farmId, farmName })} size={180} />
          <span className="text-sm text-gray-600 mt-2">
            Farm: {farmId} - {farmName}
          </span>
        </div>

        <div className="flex justify-end space-x-4 pt-4">
          <ButtonComponent
            onClick={onClose}
            customColorsStyles="bg-gray-100 text-greenPrimary hover:text-white"
          >
            Close
          </ButtonComponent>
          <ButtonComponent onClick={handlePrintQR}>Print QR</ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
};

export default FarmQRModal;
FarmQRModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  farmId: PropTypes.number.isRequired,
  farmName: PropTypes.string.isRequired
};
